import React from "react";
import { Avatar } from "./Avatar";
import { fmtScore } from "./RatingsDialog";

export const RatingsBoard = ({ rows, currentName, onOpenHistory }) => {
  if (!rows.length) {
    return (
      <p className="text-center text-slate-500 text-sm py-10" data-testid="ratings-board-empty">
        Nessuna pagella ancora. Dopo una partita, apri "Pagelle" e vota i giocatori!
      </p>
    );
  }
  return (
    <ol className="space-y-2" data-testid="ratings-board">
      {rows.map((r, i) => {
        const isMe = r.name.toLowerCase() === (currentName || "").toLowerCase();
        return (
          <li key={r.name} data-testid={`ratings-row-${r.name.toLowerCase().replace(/\s+/g, "-")}`}
            onClick={() => onOpenHistory?.({ name: r.name, photo_path: r.photo_path })}
            className={`flex items-center gap-3 rounded-2xl px-4 py-3 border cursor-pointer transition-colors hover:border-[#ccff00]/50 ${isMe ? "bg-[#ccff00]/8 border-[#ccff00]/30" : "bg-[#121b2d] border-[#1e2c4a]"}`}>
            <span className={`w-7 text-center font-heading font-extrabold ${i < 3 ? "text-[#ccff00]" : "text-slate-500"}`}>{i + 1}</span>
            <Avatar name={r.name} photoPath={r.photo_path} size={38} />
            <div className="flex-1 min-w-0">
              <p className="font-semibold text-slate-100 truncate">{r.name}</p>
              <p className="text-xs text-slate-400">{r.matches} partit{r.matches === 1 ? "a" : "e"} · {r.count} vot{r.count === 1 ? "o" : "i"}</p>
            </div>
            <span className="font-heading font-extrabold text-2xl text-[#ccff00]" data-testid={`ratings-avg-${r.name.toLowerCase().replace(/\s+/g, "-")}`}>{fmtScore(r.avg)}</span>
          </li>
        );
      })}
    </ol>
  );
};
